import {
    DF_LAT_PRO_V1_3_3,
    DF_LAT_PRO_FILENAME_V1_3_3,
    DF_LAT_LITE_V1_3_4,
    DF_LAT_LITE_FILENAME_V1_3_4,
    DF_LAT_LITE_MANUAL_JA_FILENAME_V1,
    DF_LAT_LITE_MANUAL_JA_URL_V1,
    DF_LAT_PRO_MANUAL_JA_FILENAME_V1,
    DF_LAT_PRO_MANUAL_JA_URL_V1,
} from "../../consts/Installers";

/**
 * リリースノート（DF LAT）
 * @returns JSX.Element
 */
export const ReleaseNotesDfLat = () => {
    return (
        <div>
            {/* Pro版 v2.0.0, Lite版 v2.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v2.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v2.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-08-31</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v2.0.0がリリースされました。</p>
                    <p>DF LAT Lite版 v2.0.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・TINによるDTM作成</p>
                    <p>・各ビューアのドック機能</p>
                    <p>・背景表示</p>
                    <p>・ベクターファイルインポート</p>
                    <br />
                    <p>機能改善</p>
                    <p>・地面検出・間引きロジック改良</p>
                    <p>・データ読み込み速度改善</p>
                    <p>・点群編集操作の高速化対応</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・大規模データ描画時のエラーを修正</p>
                    <p>・複合座標系データで地面検出が失敗する問題を修正</p>
                    <p>・編集ウィンドウ拡大時の距離計算不具合を修正</p>
                    <p>・その他軽微なバグを修正</p>
                    <br />
                    <p className="font-bold">■ Pro版のみ</p>
                    <p>新機能</p>
                    <p>・リアルタイムTIN表示機能</p>
                    <p>・バッチ処理機能</p>
                    <p>・データクリップ機能</p>
                    <br />
                    <p>機能改善</p>
                    <p>・データ分割時の長さ(m)指定オプションを追加</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.3, Lite版 v1.3.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.3.3</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.3.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.3.3がリリースされました。</p>
                    <p>DF LAT Lite版 v1.3.4がリリースされました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・Windowsセキュリティ機能への対応を改善</p>
                    <br />
                </div>
                <hr className="my-2"></hr>
                <p className="mt-2">ダウンロード</p>
                <a className="link-text-blue" href={DF_LAT_PRO_V1_3_3}>
                    {DF_LAT_PRO_FILENAME_V1_3_3}
                </a>
                <br />
                <a className="link-text-blue" href={DF_LAT_LITE_V1_3_4}>
                    {DF_LAT_LITE_FILENAME_V1_3_4}
                </a>
                <br />
                <a
                    className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                    href={DF_LAT_PRO_MANUAL_JA_URL_V1}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    {DF_LAT_PRO_MANUAL_JA_FILENAME_V1}
                </a>
                <br />
                <a
                    className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                    href={DF_LAT_LITE_MANUAL_JA_URL_V1}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    {DF_LAT_LITE_MANUAL_JA_FILENAME_V1}
                </a>
            </div>

            {/* Lite版 v1.3.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.3.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-02-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Lite版 v1.3.3がリリースされました。</p>
                    <br />
                    <p>機能追加</p>
                    <p>・座標変換機能をLite版で有効化</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.2, Lite版 v1.3.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.3.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.3.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-01-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.3.2がリリースされました。</p>
                    <p>DF LAT Lite版 v1.3.2がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>新機能</p>
                    <p>・SHC図作成機能を追加</p>
                    <br />
                    <p>機能改善</p>
                    <p>・CS立体図作成機能にパラメータ設定を追加</p>
                    <p>・断面作成の高速化対応</p>
                    <p>・編集操作の高速化対応</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・距離計算機能のバグを修正</p>
                    <p>・ラスタインポート時の一部バグ修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.1, Lite版 v1.3.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.3.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.3.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.3.1がリリースされました。</p>
                    <p>DF LAT Lite版 v1.3.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・Windows Updateに伴いログインに失敗する問題を修正</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.0, Lite版 v1.3.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.3.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.3.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-09-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.3.0がリリースされました。</p>
                    <p>DF LAT Lite版 v1.3.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能改善</p>
                    <p>・ログイン関連機能の改善（オフラインディアクティベーション、ライセンス期限通知機能など）</p>
                    <p>・メニューから利用規約等を確認できるよう改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・CHMやレーザー林相図作成において、大きなサイズのファイル出力に失敗する場合がある問題を修正</p>
                    <p>・その他、軽微なバグを修正</p>
                    <br />
                    <p className="font-bold">■ Pro版のみ</p>
                    <p>機能改善</p>
                    <p>・点群分割時に、領域を一部重複させるかを選択できるように改善</p>
                    <p>・DEM合成時に、重複部分を適切に結合できるよう改善</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.2.0, Lite版 v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.2.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-04-04</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.2.0がリリースされました。</p>
                    <p>DF LAT Lite版 v1.2.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能追加</p>
                    <p>・CS立体図作成機能を追加しました。</p>
                    <br />
                    <p className="font-bold">■ Pro版のみ</p>
                    <p>機能改善</p>
                    <p>・点群編集（マニュアルフィルタリング）時の断面描画処理を高速化しました。</p>
                    <p>・地面検出および点群編集で、点群にクラス情報を付与できるようになりました。</p>
                    <p>・クラス分類された点群を、クラスごとに表示できるようになりました。</p>
                    <p>・ユーザーインターフェースを調整しました。</p>
                    <p>・地面検出の詳細なパラメータを調整できるようになりました。</p>
                    <br />
                    <p className="font-bold">■ Lite版のみ</p>
                    <p>機能追加</p>
                    <p>・Pro版でのみ使用可能だった点群編集（マニュアルフィルタリング）機能を追加しました。</p>
                    <p>
                        ・全自動処理に含まれていた「地面検出」「ラスター化」「DSM作成」「CHM計算」を独立機能として追加し、パラメータ調整が可能になりました。
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.1.0, Lite版 v1.1.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.1.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-06-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.1.0がリリースされました。</p>
                    <p>DF LAT Lite版 v1.1.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ Pro版 v1.1.0向け</p>
                    <p>・DEM上でのスライス位置の指定機能を追加しました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>バグ修正</p>
                    <p>・CHM計算時に、DSMとDTMの位置がずれる場合がある問題を修正しました。</p>
                    <p>・管理者以外のユーザーでスタートメニューにショートカットが追加されない問題を修正しました。</p>
                    <br />
                    <p>その他</p>
                    <p>・ソフトウェアのデフォルトのインストール先を変更しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.1, Lite版 v1.0.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.0.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.0.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-04-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.0.1がリリースされました。</p>
                    <p>DF LAT Lite版 v1.0.1がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能追加</p>
                    <p>・レーザー林相図作成機能を追加しました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・地面検出機能の最適化を行いました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・一部のPCで起動しない問題を修正しました。</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.0, Lite版 v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro版 v1.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite版 v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-07</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro版 v1.0.0がリリースされました。</p>
                    <p>DF LAT Lite版 v1.0.0がリリースされました。</p>
                    <br />
                    <p className="font-bold">■ 共通内容</p>
                    <p>機能改善</p>
                    <p>・地面検出アルゴリズムを改良しました。</p>
                    <p>・点群描画を一部高速化しました。</p>
                    <p>・地面検出時に色情報を残すように修正しました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・特殊条件化でフィルタリング時にデータが欠ける問題を解消しました。</p>
                    <p>・DTM出力時に解像度50cmでうまくいかない問題を解消しました。</p>
                    <p></p>
                    <br />
                    <p className="font-bold">■ Pro版 v1.0.0向け</p>
                    <p>・「戻る・進む」ボタンのUIを一部修正しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.0.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-01-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>アップデート情報</p>
                    <p>・マニュアルフィルタリングに「戻る・進む」ボタンが追加されました。</p>
                    <p>・ログイン認証時のバグを修正しました。</p>
                    <p>・その他軽微なバグを修正しました。</p>
                </div>
            </div>

            {/* v1.0.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-13</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>バグ修正</p>
                    <p>・オフライン時7日間ログインできる機能の問題修正</p>
                    <br />
                    <p>機能改善</p>
                    <p>・点群間引きアルゴリズムの機能改善</p>
                </div>
            </div>

            {/* v1.0.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>バグ修正</p>
                    <p>・編集中にソフトウェアが強制終了した際の編集情報の復元</p>
                    <br />
                    <p>その他</p>
                    <p>・無料体験版</p>
                    <p>・マニュアル更新</p>
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-10-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT v1.0.0をリリースしました。</p>
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfLat;
